const escapeCell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

const exportCSV = (rows, filename = "data.csv") => {
  if (!rows.length) return;

  const headers = Object.keys(rows[0]);
  const csvLines = [
    headers.map(escapeCell).join(","),
    ...rows.map((row) => {
      if (headers.length === 0) return ""; // blank row
      return headers.map((key) => escapeCell(row[key])).join(",");
    }),
  ];

  const blob = new Blob([csvLines.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};
export default exportCSV;